export default __webpack_public_path__ + "static/media/ChemcadAppStreaming_Image.4b0fecd4.png";